"use strict";
/*
 * HSStaticMethods
 * @version: 2.5.1
 * @author: Preline Labs Ltd.
 * @license: Licensed under MIT and Preline UI Fair Use License (https://preline.co/docs/license.html)
 * Copyright 2024 Preline Labs Ltd.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var utils_1 = require("../utils");
var index_1 = require("../spa/index");
var HSStaticMethods = {
    getClassProperty: utils_1.getClassProperty,
    afterTransition: utils_1.afterTransition,
    autoInit: function (collection) {
        if (collection === void 0) { collection = 'all'; }
        if (collection === 'all') {
            index_1.COLLECTIONS.forEach(function (_a) {
                var fn = _a.fn;
                fn === null || fn === void 0 ? void 0 : fn.autoInit();
            });
        }
        else {
            index_1.COLLECTIONS.forEach(function (_a) {
                var key = _a.key, fn = _a.fn;
                if (collection.includes(key))
                    fn === null || fn === void 0 ? void 0 : fn.autoInit();
            });
        }
    },
    cleanCollection: function (name) {
        if (name === void 0) { name = 'all'; }
        if (name === 'all') {
            index_1.COLLECTIONS.forEach(function (_a) {
                var collection = _a.collection;
                if (window[collection] instanceof Array) {
                    window[collection] = [];
                }
            });
        }
        else {
            index_1.COLLECTIONS.forEach(function (_a) {
                var key = _a.key, collection = _a.collection;
                if (name.includes(key) &&
                    window[collection] instanceof Array) {
                    window[collection] = [];
                }
            });
        }
    },
};
if (typeof window !== 'undefined') {
    window.HSStaticMethods = HSStaticMethods;
}
exports.default = HSStaticMethods;
